import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      retry: (failureCount, error) => {
        // Don't retry on 401 errors - let the auth system handle token refresh
        if (error?.message?.includes("Request was not authorized"))
          return false;
        // Don't retry on 404 or other client errors
        if (error?.message?.includes("404"))
          return false;
        // Retry up to 2 times for other errors with exponential backoff
        return failureCount < 2;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
